import { ReactComponent as CopyLinkIcon } from 'assets/copy-link.svg';
import { ReactComponent as DeleteIcon } from 'assets/delete-red.svg';
import { ReactComponent as EditIcon } from 'assets/edit.svg';
import { ActionModel } from './types';

export const actions: ActionModel[] = [
  {
    id: 'edit',
    label: 'Edit Deal',
    Icon: EditIcon,
  },
  {
    id: 'copy',
    label: 'Copy Link',
    Icon: CopyLinkIcon,
  },
  {
    id: 'delete',
    label: 'Delete',
    Icon: DeleteIcon,
  },
];
